export default {
  SELECT_RETURN_ITEM: 'Select products for return',
  PLEASE_SELECT_A_RETURN_ITEM: 'Please select the product to return',
  SELECT_ALL: 'Select all',
  SELECT_RETURN_REASON: 'Select a return reason',
  SUBMIT_RETURN: 'Apply for return',
  PLEASE_SELECT_RETURN_ITEM: 'Please select the product you need to return',
  PLEASE_SELECT_RETURN_REASON: 'Please select a return reason',
  RETURN_REASON: 'Return reason',
  ADD_INSTRUCTIONS: 'Add an explanation',
  QUESTION_DESCRIPTION: 'Problem description',
  FILL_IN_DETAIL_DESCRIPTION:
    'Please fill in your problem description in detail',
  REFUND_TO: 'Refund since',
  WECHAT_PAY: 'WeChat Pay',
  STARTING_REFUND_7_WORK_DAYS:
    '1-7 working days after shopping returned to Amazon Global Stores warehouse',
  PICKUP_ADDRESS: 'Pick-up address',
  ORIGINAL_ORDER_ADDRESS: 'Order delivery address',
  TOTAL_REFUND: 'Order total',
  RETURN_SHIPPING_FEE: 'Shipping fee',
  DEDUCT_FROM_TOTAL_RETURN: 'Deducted from the total refund',
  TOTAL_REFUND_AMOUNT: 'Refund amount',
  SUBMIT_RETURN_QUEST: 'Submit',
  ONLY_FOR: 'Returns can only be made by ',
  AVAILABLE_FOR_SUMBIT_RETURN: '',
  RETURN_SUBMISSION_RESULT: 'Return application result',
  SUCCESSFULLY_SUBMITTED_RETURN: 'Return application submitted successfully',
  RETURN_FAILED: 'Return failed',
  SUMBIT_DATE: 'Submission date',
  DATE_FORMAT: 'YYYY/MM/DD',
  PLEASE_FILL_NAME_ID_ADDRESS_YIKEMAN_WEBSITE:
    'Yi Ke Man, the domestic logistics carrier authorized by Amazon, will notify you by text message within 48 hours, go to the Yi Ke Man official website to fill in your name, identity card information (to be used for customs clearance in the process of returning goods to the Amazon  Global Stores warehouse) and pick-up address.',
  YIKEMAN_ASSIGN_YUANTONG_ARRANGE_PICKUP_TIME:
    'After Yi Ke Man receives your customs clearance information, it will entrust YTO Express to contact you through the mobile number you provided within 48 hours to arrange the time for pick-up.',
  NO_PACKAGING_PROVIDED_DURING_PICK_UP:
    'Before the delivery comes to pick up, no packaging of any goods is provided, please ensure that your goods are well packaged to avoid any damage during transportation.',
  ESTIMATED_TOTAL_REFUND: 'Estimated total refund',
  REFUND_ARRIVED_ORIGINAL_ACCOUNT:
    'After the Amazon  Global Stores warehouse receives the returned goods and confirms that they meet the return conditions, it will arrange a refund for you, which will be returned to your original payment account on average 1-7 working days later.',
  VIEW_RETURN_DETAILS: 'View return details',
  AFTER_SALE: 'Return',
  AFTER_SALE_DETAIL: 'After-sales details',
  RETURN_DETAIL: 'Return details',
  APPLICATION_DATE: 'Application date',
  RETURN_ORDER_TIME: 'Return submitted',
  ORIGINAL_DELIVERY_ADDRESS: 'Original order delivery address',
  REFUND_INSTRUCTIONS: 'Refund explanation',
  REFUND_START_RETURNED_TO_AMAZON_OVERSEAS_WAREHOUSE:
    'The refund will start within 1-7 working days after the goods are returned to the Amazon  Global Stores warehouse',
  NOT_SUPPORT_NO_REASON_REFUND: 'Not supported for 30-day no-reason return',
  MY_ORDER: 'My orders',
  ORDER_DETAIL: 'Order details',
  ORDER_NUMBER: 'Order ID',
  ORDER_CREATION_TIME: 'Created on',
  ORDERER: 'Ordered',
  KYC_ERROR_ABOUT_TO_BE_CANCELLED:
    "The orderer's information does not match the payer's information, and will be canceled soon",
  KYC_ERROR_CANCELED:
    "The orderer's information does not match the payer's information, and has been canceled",
  CANNOT_CANCEL_ORDER: 'Unable to cancel the order',
  CURREN_ORDER_CANNOT_BE_CANCELLED:
    'As some items in the order have entered the "Order processing" or "Ready for dispatch" status and cannot be terminated, and Amazon  Global Stores Purchase does not support partial order cancellation, the current order cannot be canceled.',
  IMPORT_FEE_INSTRUCTION: 'Explanation of import fees',
  G_S_ESTIMATE_CHARGE_IMPORT_TAX_FEE:
    'Amazon  Global Stores Purchase will estimate and collect related import taxes and fees according to customs clearance policies when you place an order',
  SHIPPING_FEE_INSTRUCTION: 'Explanation of shipping costs',
  CONTINUE_APPLYING_FOR_RETURNS:
    'This order has saved you ¥{price}, do you continue to apply for a return?',
  ACTUAL_SHIPPING_FEE_AFTER_YOU_PLACED_ORDER:
    'After you place an order on Amazon  Global Stores Purchase, the actual logistics and distribution costs incurred',
  G_SITEMS_CANNOT_PROVIDE_INVOICE:
    'Invoice unavailable in Global Stores purchase',
  VIEW_LOGISTICS: 'View logistics',
  CANCEL_ORDER: 'Cancel order',
  APPLY_RETURN: 'Review return request',
  REPURCHASE: 'Buy again',
  VIEW_HELP: 'View help',
  NO_PARTIAL_ORDER_CANCALLATION:
    'Partial order cancellations are not supported, canceling the order will cancel the entire order. Items in the process of being processed or ready for dispatch cannot be canceled. If you need to buy again, the real-time price on the page will prevail.',
  EVALUATE_ORDER: 'Go to review',
  SELECT_CANCEL_ASIN: 'Select cancel items',
  CONFIRM_CANCEL_ALL: 'Confirm to cancel all',
  SELECT_CANCEL_REASON: 'Select a reason for cancellation',
  PLEASE_SELECT_CANCEL_REASON: 'Please select a reason for cancellation',
  CANCEL_FAILED: 'Cancellation failed',
  ADD_TO_CART_SUCCEED: 'Added to cart',
  ADD_TO_CART_FAILED: 'Failed to add to cart',
  LOGISTICS_INFORMATION: 'Logistics information',
  PARCEL: 'Parcel',
  TRACKING_PARCEL_NUMBER: 'Tracking package number',
  ESTIMATED_ARRIVAL_TIME: 'Estimated arrival time',
  PIECE: 'Pieces',
  ITEMS_TOTAL_PRICE: 'Items',
  DISCOUNT: 'Discount',
  IMPORT_FEE: 'Import fees',
  SHIPPING_FEE: 'Shipping cost',
  TOTAL_AMOUNT: 'Total',
  NO_ORDER_INFORMATION: 'No order information',
  NO_AS_ORDER_INFORMATION: 'No after-sales information',
  NO_REVIEW_INFORMATION: 'No review information',
  NO_MORE: 'No more',
  TOTAL: 'Total',
  ESTIMATED: 'Arriving at ',
  ARRIVED: '',
  AUTHENTICITY_GUARANTEE: 'Authenticity guarantee',
  CUSTOMER_SERVICE: 'Chinese customer service',
  USUALLY_TAKES: 'Global Stores direct mail usually takes',
  A_FEW_DAYS_TO_ARRIVE: '4-12 days to deliver',
  CANCEL_RETURN_REQUEST: 'Cancel return application',
  CANCEL_RETURN_OR_NOT: 'Do you want to cancel the return application process?',
  CONTINUE_RETURN: 'Continue to return',
  CANCEL_RETURN: 'Cancel return',
  CANCEL_REASONS: {
    ADD_REMOVE: 'Need to add/reduce products',
    WRONG_PAYMENT_METHOD: 'Need to change payment method',
    WRONG_SHIPPING_ADDRESS: 'Need to change delivery address',
    WITHOUT_EST_ARR_DATE_DATE_TOO_LATE:
      'No estimated delivery time provided or the estimated delivery time is too long',
    FOUND_CHEAPER: 'Found the same item at a lower price elsewhere',
    INCORRECT_INFO: 'Page information is incorrect',
    NOT_FULL_FILLED: 'Long time no shipment',
    WRONG_ORDER: 'Ordered by mistake',
    CHANGE_MIND: "Changed mind, don't want it anymore",
    PROMOTION_NOT_APPLIED: 'Did not enjoy the promotional discount',
    OTHER: 'Other'
  },
  ORDER_LIST_STATUS: {
    ALL: 'All orders',
    NOSHIPMENT: 'To be shipped',
    DELIVERYING: 'To be received',
    GOCOMMENT: 'To be reviewed',
    CANCEL: 'Canceled'
  },
  SHIPMENT_STATUS: {
    INTERNATIONAL: 'In International shipping',
    UNDISPLAYED: 'In customs',
    DOMESTIC: 'In domestic shipping',
    DELIVERED: 'Delivered successfully'
  },
  FRONT_END_STATUS: {
    KYC_ERROR:
      "The orderer's information does not match the payer's information, has been canceled",
    WAITING_PAY: 'The order has been submitted, unpaid orders will be canceled',
    CANCEL: 'Canceled',
    SHIPMENT_EMPTY: 'Order submitted',
    WAITING_DELIVERY: 'Order submitted',
    DELIVERYING: 'Shipped',
    DELIVERYED: 'Delivered successfully',
    DELIVERY_FAILED: 'Delivery failed',
    CRETURNS_RETURNING: 'Return application submitted',
    CRETURNS_REFUND: 'Refunded',
    CRETURNS_UNDELIVERED_RETURNING: 'Package cannot be delivered, returning',
    CRETURNS_UNDELIVERED_REFUNDED: 'Package cannot be delivered, refunded',
    RETURNING: 'Returning',
    RETURNED: 'Refunded',
    WAITING_CONFIRMATION: 'Order confirmation in progress'
  },
  REFUNDABLE: 'Refundable',
  CANCEL_ORDER_INSTRUCTION: 'Cancellation order explanation',
  CONTACT_CUSTOMER_SERVICE_TO_CANCEL_ORDER:
    'Due to system upgrade, please contact customer service to apply for order cancellation. We apologize for the inconvenience caused to your operation.',
  APPLY_FOR_RETURN_REFUND_INSTRUCTION:
    'Explanation of the application for return and refund',
  CONTACT_CUSTOMER_SERVICE_FOR_RETURN_AND_REFUND:
    'Due to system reasons, please try again later or contact customer service to apply for a return and refund. We deeply apologize for the inconvenience caused to your operation.',
  THE_ORDER_HAS_BEEN_SUCCESSFULLY_CANCELLED:
    'The order has been successfully canceled',
  REFUND_WITHIN_7_WORK_DAYS:
    'Refunds will be returned to the original payment method within an average of 1-7 working days',
  CUSTOMER_REVIEW: 'Review center',
  WAITING_FOR_REVIEW: 'Pending review',
  REVIEWED: 'Reviewed/Additional review',
  GO_REVIEW: 'Go to review',
  FAILED_REVIEW_PLEASE_RE_EVALUATE:
    'The review did not pass the audit, please review',
  PRODUCT_EVALUATION_REVIEW_IN_PROGRESS_PLEASE_WAITING:
    'Several product reviews are under review, need to wait 1-3 working days, the review will take effect once approved',
  RULE: 'Rules',
  DELETE_REVIEW: 'Delete review',
  CONFIRM_DELETE: 'Confirm to delete',
  CONFIRM_TO_DELETE_THIS_REVIEW:
    "Your review can affect more buyers' purchase decisions. Confirm deletion will permanently remove this review",
  WRITE_A_REVIEW_FOR_THE_ASIN: 'Write a review for the product',
  WRITE_REVIEWS_AND_RECEIVE_BENEFITS: 'Write a review to get rewards',
  DETAIL: 'Details',
  WELCOME_TO_WRITE_DOWN_YOUR_USAGE_EXPERIENCE:
    'Welcome to write down your usage experience and preferences, reviews with more than 10 words are valid',
  CAMPAIGN_REWARD_RULES: 'Activity reward rules',
  PLEASE_FILL_IN_THE_EVALUATION_CONTENT: 'Please fill in the review content',
  WORD_COUNT_CAN_BE_PUBLISHED:
    'You need to write more than 10 words to publish',
  REACH_THE_REVIEW_WORDS_LIMIT: 'Reached the 200-word input limit',
  DELETE_SUCCESSFULLY: 'Deleted successfully',
  DELETE_FAILED: 'Deletion Failed',
  THE_REVIEW_HAS_BEEN_SUBMITTED:
    'The review has been submitted, it will take effect after approval',
  CANCELLED_RETURN: 'Return canceled',
  PAYMENT_METHOD: {
    WECHAT_PAY: 'WeChat Pay',
    CHINA_UNION_PAY: 'China Union Pay',
    CREDIT_CARD: 'Credit card',
    GIFT_CARD: 'Gift card',
    CASH_ON_DELIVERY: 'Cash on delivery',
    EXTERNAL_PAYMENT: 'External payment',
    PAYMENT_PLATFORM: 'Payment platform',
    ALIPAY: 'Alipay',
    HSBC_BANK: 'HSBC bank card',
    ELSE: 'Others'
  },
  IN_CALCULATION: 'Calculating',
  CONTACT_CS_CONFIRM_RETURN: 'Contact customer service to confirm return',
  NOT_SUPPORT_REFUND: 'Ineligible for return within 30 days of receipt'
};
